import { Grid } from '@farewill/ui'

import InputFloating from 'components/form/input-floating'
import { getLifeInsuranceTotals } from 'routes/probate-estate/fact-find/get-totals'
import { ProbateEstateItem } from 'lib/models/probate-estate'
import {
  ASSET_OWNERSHIP,
  LIFE_INSURANCE_POLICY_SCHEMA,
} from 'lib/probate/estate-questionnaire-schema'

import OwnershipFields from './ownership-fields'
import RecordsSection, { RecordsSubSectionProps } from './records-section'

const POLICY_TYPE_OPTIONS = [
  { label: 'Not asked', value: ASSET_OWNERSHIP.NOT_ASKED },
  { label: 'Single policy', value: ASSET_OWNERSHIP.SOLE },
  { label: 'Joint policy', value: ASSET_OWNERSHIP.JOINT },
]

// the shared totals only count sole, joint and null ownership, so a policy
// whose type wasn't asked is counted as unspecified
const withNotAskedAsUnspecified = (items: ProbateEstateItem[]) =>
  items.map((item) =>
    item.attributes.ownership === ASSET_OWNERSHIP.NOT_ASKED
      ? ({
          ...item,
          attributes: { ...item.attributes, ownership: null },
        } as unknown as ProbateEstateItem)
      : item
  )

const LifeInsurance = ({
  collection,
  sectionActive,
  saveProbateEstateField,
}: RecordsSubSectionProps) => {
  const { total, sole, joint } = getLifeInsuranceTotals(
    withNotAskedAsUnspecified(collection.items as ProbateEstateItem[])
  )

  return (
    <RecordsSection
      heading="2.8 Life insurance"
      cardType="Policy"
      addLabel="Add policy"
      toggleName="lifeInsuranceSectionActive"
      sectionActive={sectionActive}
      saveProbateEstateField={saveProbateEstateField}
      collection={collection}
      schema={LIFE_INSURANCE_POLICY_SCHEMA}
      totals={{
        total,
        sole,
        joint,
        soleLabel: 'Single policies',
        jointLabel: 'Share of joint policies',
      }}
      renderFields={({ handleSave, pairedFieldSpan }) => (
        <>
          <Grid.Item span={pairedFieldSpan}>
            <InputFloating
              name="providerName"
              label="Provider name"
              handleSave={handleSave}
            />
          </Grid.Item>
          <Grid.Item span={pairedFieldSpan}>
            <InputFloating
              name="referenceNumber"
              label="Policy or reference number"
              handleSave={handleSave}
            />
          </Grid.Item>
          <Grid.Item span={12}>
            <InputFloating
              name="value"
              label="Value (£)"
              isCurrency
              handleSave={handleSave}
            />
          </Grid.Item>
          <OwnershipFields
            handleSave={handleSave}
            label="Policy type"
            options={POLICY_TYPE_OPTIONS}
            // three options don't fit on one line in a half-width card
            inline={pairedFieldSpan === 6}
          />
        </>
      )}
    />
  )
}

export default LifeInsurance
